import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { labelFor, colorFor } from './leadStatus';

// Her istekte cagrilir - bkz. DiscoveryView.js/QueueView.js'teki ayni aciklama.
const getAuthHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });

const StatsView = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get('/api/admin/callcenter/stats', getAuthHeaders())
      .then(res => setStats(res.data))
      .catch(err => console.error(err));
  }, []);

  if (!stats) return <div style={{ color: '#6b7280' }}>Yükleniyor...</div>;

  const maxFunnel = Math.max(1, ...stats.funnel.map(f => f.count));
  const budget = stats.usage.monthly_budget_usd;
  const spent = parseFloat(stats.usage.est_cost_usd_this_month) || 0;
  const budgetPct = budget ? Math.min(100, Math.round((spent / budget) * 100)) : null;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        <div style={{ background: '#eff6ff', padding: '14px 20px', borderRadius: 8, minWidth: 160 }}>
          <div style={{ fontSize: 12, color: '#2563eb' }}>Bugünkü Aramalar</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#1e293b' }}>{stats.calls_today}</div>
        </div>
        <div style={{ background: '#fef3c7', padding: '14px 20px', borderRadius: 8, minWidth: 220 }}>
          <div style={{ fontSize: 12, color: '#92400e' }}>Bu Ay Google İstekleri</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#1e293b' }}>{stats.usage.requests_this_month}</div>
          <div style={{ fontSize: 12, color: '#92400e' }}>
            ~${spent.toFixed(2)}{budget ? ` / $${budget.toFixed(0)}` : ''}
          </div>
          {budgetPct !== null && (
            <div style={{ background: '#fde68a', borderRadius: 4, height: 6, marginTop: 6 }}>
              <div style={{ width: `${budgetPct}%`, background: budgetPct > 90 ? '#dc2626' : '#f59e0b', height: 6, borderRadius: 4 }} />
            </div>
          )}
        </div>
      </div>

      <div style={{ marginBottom: 24 }}>
        <div style={{ fontWeight: 600, marginBottom: 10 }}>Durum Dağılımı (Huni)</div>
        {stats.funnel.map(f => (
          <div key={f.status} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <div style={{ width: 140, fontSize: 13 }}>{labelFor(f.status)}</div>
            <div style={{ flex: 1, background: '#f1f5f9', borderRadius: 4, height: 18 }}>
              <div style={{ width: `${(f.count / maxFunnel) * 100}%`, background: colorFor(f.status), height: 18, borderRadius: 4 }} />
            </div>
            <div style={{ width: 30, fontSize: 13, textAlign: 'right' }}>{f.count}</div>
          </div>
        ))}
      </div>

      <div>
        <div style={{ fontWeight: 600, marginBottom: 10 }}>Bugünkü Personel Liderlik Tablosu</div>
        {stats.leaderboard.length === 0 && <div style={{ color: '#6b7280', fontSize: 13 }}>Bugün henüz arama yapılmadı.</div>}
        {stats.leaderboard.map(row => (
          <div key={row.admin_id || 'unknown'} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f1f5f9' }}>
            <span>{row.username || 'Bilinmiyor'}</span>
            <span style={{ fontWeight: 600 }}>{row.call_count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsView;
